export const PLANS = [
  { key: "free", label: "Free", color: "#94a3b8" },
  { key: "individual", label: "Individual", color: "#38bdf8" },
  { key: "flex", label: "Flex", color: "#818cf8" },
  { key: "full_access", label: "Full Access", color: "#f59e0b" },
];

const rawPlan = (u) => u.active_plan ?? u.subscription_plan ?? u.plan ?? u.subscription?.active_plan ?? u.subscription?.plan;

export const hasPlan = (u) => rawPlan(u) != null && rawPlan(u) !== "";

export const planOf = (u) => {
  if (!hasPlan(u)) return null;
  const v = String(rawPlan(u)).toLowerCase().replace(/[\s-]+/g, "_");
  if (v === "none" || v.includes("free")) return "free";
  if (v.includes("full")) return "full_access";
  if (v.includes("flex")) return "flex";
  if (v.includes("individual") || v.includes("single")) return "individual";
  return v;
};

export const planInfo = (key) => PLANS.find((p) => p.key === key) ?? { key, label: key, color: "#64748b" };
